



























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import { AttributeMixin } from '@/mixins';
import { SearchMixin } from '@acgn/herm/src/mixins';
import { AcgnTargetEdit, AcgnBubgetPriceEdit } from '@/components';
import { DatePicker } from 'element-ui';
import dayjs from 'dayjs';
import { openUrl } from '@/util';
import moment from 'moment';
import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
  AcgnPermission,
} from '@acgn/herm/src/ui';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import event from '@acgn/herm/src/util/event';

const StatisticAction = namespace('desk/statistic').Action;
const ComicAction = namespace('desk/comic').Action;
const StatisticGetter = namespace('desk/statistic').Getter;
const ComicGetter = namespace('desk/comic').Getter;

interface SearchType {
  // 项目搜索字段
  project_name?: string; // 漫画名称
  page?: number; // 当前页码
  time?: string; // 开始时间
}

interface PopTargetData {
  // 弹窗
  visible: boolean; // 是否显示
  data: any; // 弹窗交互数据
}

// 组件申明
@Component({
  components: {
    AcgnSearchWrap,
    AcgnTable,
    AcgnTopButton,
    AcgnTargetEdit,
    AcgnBubgetPriceEdit,
    [DatePicker.name]: DatePicker,
  },
  mixins: [AttributeMixin, SearchMixin],
})
export default class AcgnStatisticProjectAll extends Vue {
  @Prop({ default: '' }) public exportCode: string; // 导出权限码
  @StatisticAction private getProjectBudget: any; // 获取项目预算
  @ComicAction private getProjectListByName: any; // 根据关键词获取漫画项目列表(模糊搜索))
  @StatisticGetter private loadings: any; // 员工loading

  private searchForm: SearchType = {
    // 头部筛选项
    project_name: '',
    page: 1,
    time: moment(Date.now()).format('YYYY-MM'),
  };

  private comics: any = [];

  private timeRange: any = this.formatYM(Date.now());

  private targetData: PopTargetData = {
    // 弹窗
    visible: false,
    data: null,
  };

  private pageConfig: any = {
    // 分页数据
    total: 0,
    currentPage: 1,
  };

  private pickerOptions: any = {
    // disabledDate(time: any) {
    //   return time.getTime() + 86400000 <= Date.now(); // 选当前时间之后的时间
    // }
  };
  // 列表配置
  private tableConfig: any = {
    maxHeight: {

    },
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        label: '统计时间',
        prop: 'time',
      },
      {
        label: '项目',
        prop: 'project_name',
      },
      {
        minWidth: 100,
        label: '已过审环节数',
        prop: 'approve_link_num',
      },
      {
        minWidth: 100,
        label: '已结算环节数',
        prop: 'settle_num',
      },
      {
        minWidth: 100,
        label: '已结算总价',
        prop: 'all_price',
      },
      {
        minWidth: 100,
        label: '预算成本',
        prop: 'number',
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              icon: 'ift-chapter',
              color: '#73c800',
              text: '修改预算成本',
              type: 'edit',
              disabled: false,
              permission: ['6013'],
            },
          ];
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                this.onListAction(item);
              },
            },
          });
        },
      },
    ],
    data: [],
  };

  private formatYM(time: number) {
  if (typeof time !== 'number') {
    return '无';
  }
  return time ? moment(time).format('YYYY/MM/DD HH:mm') : '无';
}

  private async created() {
    const cacheForm: any = this.$getFormCache();
    this.searchForm = { ...this.searchForm, ...cacheForm };
    if (this.searchForm.page) {
      // 如果有缓存页码，先赋值
      this.pageConfig.currentPage = this.searchForm.page;
    }
    // await this.remoteComicList();
    // this.search();
  }

  // 漫画加载
  // private async remoteComicList() {
  //   const { result } = await this.getProjectListByName();
  //   this.comics = result;
  // if (!this.searchForm.project_id && this.comics.length > 0) {
  // this.searchForm.project_id = this.comics[0].id;
  // }
  //   this.search();
  // }

  // 列表操作项
  private onListAction(item: any) {
    const row = item.row;
    switch (item.type) {
      case 'edit':
        const data = {
          time: row.time,
          project_id: row.project_id,
          num: row.number,
        };
        this.doEdit(data, row.project_name);
        break;
    }
  }

  private doEdit(data: any, name: string) {
    this.targetData.data = {
      data,
      name,
    };
    this.targetData.visible = true;
  }

  private renderTarget(row: any) {
    const schedule = row.schedule;
    const info =
      schedule.target_num === 0
        ? '未设定目标'
        : `${schedule.target_type === 1 ? '环节数' : '件数'}:
     ${schedule.finish_num}/${schedule.target_num}`;
    return <span>{`${schedule.period}${info}`}</span>;
  }

  // 刷新当前页
  private reloadList() {
    this.initSearh({ page: this.pageConfig.currentPage });
  }

  // 搜索
  private search() {
    this.initSearh({ page: 1 });
  }

  // table组件获取数据更新数据接口
  private async initSearh({ page }: { page: any }) {
    // if (!this.searchForm.project_id) {
    //   return;
    // }
    const { tableConfig, pageConfig } = this;
    const options = {
      ...filterEmpty(this.searchForm),
      page,
      size: 30,
    };

    const { result } = await this.getProjectBudget(options);
    const pager = result.pager;
    tableConfig.data = result.list;
    pageConfig.currentPage = pager.page;
    pageConfig.pageSize = pager.page_size;
    pageConfig.total = pager.total_count;
    const { page_size, ...args } = options;
    this.$setFormCache({ ...args });
  }

  private changeTimeFrame(val: any) {
    this.searchForm.time = val ? val : '';
    this.search();
  }

  private getSearchOptions() {
    return {
      ...filterEmpty(this.searchForm),
      page: 1,
      size: 10000,
    };
  }

  private exportExcel() {
    openUrl(
      `/api/v1/project/getprojectbudget?export=1`,
      this.getSearchOptions(),
    );
  }

}
